import React from 'react';
import FileFolder from './FileFolder';
import FileDropzone from './FileDropzone';

interface ISingleFileDropzoneProps {
  onDrop: (file: File) => void | Promise<void>;
  openOnClick?: boolean;
  children?: JSX.Element;
  label?: string;
  icon?: string;
}

const SingleFileDropzone: React.FC<ISingleFileDropzoneProps> = (props) => {
  const onDrop = (folder: FileFolder) => {
    console.log('folder > ', folder);    
    if (!folder.emptyChildren() || !folder.hasFiles()) {
      throw new Error('Expected plain files');
    }

    const files = folder.getFiles();
    if (files.length !== 1) {
      throw new Error('Expected single file');
    }    
    return props.onDrop(files[0]);
  };

  return (
    <FileDropzone
      icon={props.icon}
      label={props.label}
      onDrop={onDrop}
      openOnClick={props.openOnClick}
      multiple={false}
    >
      {props.children && <>{props.children}</>}
    </FileDropzone>
  );
};

export default SingleFileDropzone;
